
import { Vue } from 'vue-property-decorator';

const Login = Vue.extend({});
export default Login;
